import React, { useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import axiosMain from '../../services';
import AuthLayout from '../Auth/AuthLayout';

const VerifyEmail = (props) => {
  const [emailValue, setEmailValue] = useState('');
  const [resendEmail, setResendEmail] = useState('');
  const [resendMsg, setResendMsg] = useState(null);
  const [resendErr, setResendErr] = useState(null);
  const [resending, setResending] = useState(false);

  useEffect(() => {
    const e = props.location.state && props.location.state.email;
    if (e) {
      setEmailValue(e);
      setResendEmail(e);
    }
  }, [props.location.state]);

  const resend = async () => {
    setResendMsg(null);
    setResendErr(null);
    const target = (resendEmail || emailValue || '').trim().toLowerCase();
    if (!target) {
      setResendErr('Enter your email to resend verification.');
      return;
    }
    setResending(true);
    try {
      const { data } = await axiosMain.post('/auth/resend-verification', { email: target });
      setResendMsg(data.message || 'If the account exists and is unverified, we sent a new link.');
    } catch (e) {
      setResendErr(
        (e.response && e.response.data && e.response.data.message) || 'Could not resend right now.'
      );
    } finally {
      setResending(false);
    }
  };

  return (
    <AuthLayout title="Verify your email">
      <p>
        We sent a verification link
        {emailValue ? (
          <>
            {' '}
            to <strong className="text-dark">{emailValue}</strong>
          </>
        ) : null}
        . Open the email and click the link to activate your account.
      </p>
      <p className="mt-3">
        <Link to="/sign-in">Back to sign in</Link>
      </p>
      <hr />
      <h6 className="mb-2">Didn&apos;t get the email?</h6>
      {resendErr ? <p style={{ color: 'red' }}>{resendErr}</p> : null}
      {resendMsg ? <p style={{ color: 'green' }}>{resendMsg}</p> : null}
      <div className="form-group">
        <input
          type="email"
          className="form-control"
          placeholder="Your email"
          value={resendEmail}
          onChange={(e) => setResendEmail(e.target.value)}
        />
      </div>
      <button type="button" className="btn btn-outline-primary btn-block" disabled={resending} onClick={resend}>
        {resending ? 'Sending…' : 'Resend verification link'}
      </button>
    </AuthLayout>
  );
};

export default withRouter(VerifyEmail);
